var map = {
	"./ALP.pdf": 7796,
	"./CRAFT_MLSys_poster.pdf": 733,
	"./CRAFT_MLSys_slides.pdf": 2726,
	"./DPWatch.pdf": 9346,
	"./DaeMon.pdf": 6724,
	"./IISWC_Camera_Ready.pdf": 8642,
	"./accelerating-pointer-chasing.pdf": 5729,
	"./ace.pdf": 441,
	"./arc.pdf": 3394,
	"./caba-gpu-slides-lightning.pdf": 9543,
	"./caba-gpu-slides.pdf": 1030,
	"./chargecache.pdf": 9334,
	"./coordx.pdf": 6421,
	"./core-assisted-bottleneck-acceleration.pdf": 4540,
	"./craft.pdf": 3546,
	"./cross-layer-abstractions.pdf": 7202,
	"./crow.pdf": 9312,
	"./damov.pdf": 1307,
	"./disorf.pdf": 3379,
	"./distnerfc_poster.pdf": 3644,
	"./distnerfc_slides.pdf": 3190,
	"./echo.pdf": 5428,
	"./expressive-memory-lightning.pdf": 8335,
	"./expressive-memory.pdf": 7315,
	"./gaia.pdf": 2967,
	"./genstore.pdf": 605,
	"./gpupool.pdf": 9294,
	"./locality-descriptor-lightning.pdf": 8130,
	"./locality-descriptor-slides.pdf": 6071,
	"./locality-descriptor.pdf": 6447,
	"./merg3r.pdf": 9440,
	"./metasys.pdf": 4081,
	"./qua-trng.pdf": 5909,
	"./smash.pdf": 7709,
	"./softmc.pdf": 3275,
	"./syncron.pdf": 2574,
	"./sysscale.pdf": 2232,
	"./thesis-slide.pdf": 1097,
	"./thesis.pdf": 3036,
	"./toggle-aware-compression.pdf": 4107,
	"./tom.pdf": 1249,
	"./voxelcache.pdf": 8495,
	"./zorua-lightning.pdf": 3947,
	"./zorua-poster.pdf": 1903,
	"./zorua-slides.pdf": 9767,
	"./zorua.pdf": 2195
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2057;